module.exports = __webpack_public_path__ + "img/hc_pro_seven_3.3b23668a.jpg";